/**
 * SeasonalTheme — Erkennt die aktuelle Jahreszeit und wendet das passende Theme an
 * @copyright reDim GmbH | @link https://www.redim.de | @contact team@redim.de
 */

const SEASONS = {
    // Spezial-Events (haben Vorrang)
    christmas: { start: [12, 15], end: [1, 6], class: 'season-christmas' },
    halloween: { start: [10, 20], end: [11, 2], class: 'season-halloween' },

    // Jahreszeiten
    winter: { start: [12, 1], end: [2, 28], class: 'season-winter' },
    spring: { start: [3, 1], end: [5, 31], class: 'season-spring' },
    // Sommer = Default (Juni-August), kein Override
    autumn: { start: [9, 1], end: [11, 30], class: 'season-autumn' }
};

/**
 * Prüft ob ein Datum in einem Bereich liegt (unterstützt Jahreswechsel)
 */
function isInRange(month, day, start, end) {
    const current = month * 100 + day;
    const rangeStart = start[0] * 100 + start[1];
    const rangeEnd = end[0] * 100 + end[1];

    if (rangeStart <= rangeEnd) {
        return current >= rangeStart && current <= rangeEnd;
    }
    // Jahreswechsel (z.B. Dez-Jan)
    return current >= rangeStart || current <= rangeEnd;
}

/**
 * Ermittelt die aktuelle Saison
 * @returns {string|null} Season-Class oder null (Sommer = Default)
 */
export function getCurrentSeason() {
    const now = new Date();
    const month = now.getMonth() + 1; // 1-12
    const day = now.getDate();

    // Spezial-Events zuerst prüfen (haben Vorrang)
    if (isInRange(month, day, SEASONS.christmas.start, SEASONS.christmas.end)) {
        return SEASONS.christmas.class;
    }
    if (isInRange(month, day, SEASONS.halloween.start, SEASONS.halloween.end)) {
        return SEASONS.halloween.class;
    }

    // Jahreszeiten
    for (const [, season] of Object.entries(SEASONS)) {
        if (season.class.includes('christmas') || season.class.includes('halloween')) continue;
        if (isInRange(month, day, season.start, season.end)) {
            return season.class;
        }
    }

    return null; // Sommer (Default)
}

/**
 * Wendet das saisonale Theme auf den Body an
 */
export function applySeasonalTheme() {
    const season = getCurrentSeason();

    // Alle Season-Classes entfernen
    document.body.classList.remove(
        'season-winter', 'season-spring', 'season-autumn',
        'season-halloween', 'season-christmas'
    );

    if (season) {
        document.body.classList.add(season);
    }

    return season;
}
